import React, { useEffect, useState } from 'react';
import { AlertTriangle, Menu, Phone, X } from 'lucide-react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { DMPLogo } from '../brand/DMPLogo';
const links = [{
  to: '/citizen',
  label: 'হোম',
  end: true
}, {
  to: '/citizen/scan',
  label: 'QR স্ক্যান'
}, {
  to: '/citizen/manual',
  label: 'ম্যানুয়াল যাচাই'
}, {
  to: '/citizen/track',
  label: 'অভিযোগের অবস্থা'
}, {
  to: '/citizen/guidelines',
  label: 'নাগরিক নির্দেশনা'
}];
export function CitizenLayout() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-[#F4F7FB]" data-id="element-170" data-mp="5gvlfmfznj76">
      <div className="no-print bg-[#006A4E] text-[12px] text-white" data-id="element-171" data-mp="346ndv9hyvc9b">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-1.5" data-id="element-172" data-mp="346dmpil6qz21">
          <span data-id="element-173" data-mp="3945qpaz3ubml">গণপ্রজাতন্ত্রী বাংলাদেশ সরকার • বাংলাদেশ পুলিশ</span>
          <span className="hidden sm:inline" data-id="element-174" data-mp="5uwbzagmlv82">অফিসিয়াল যাচাই পোর্টাল (প্রোটোটাইপ)</span>
        </div>
      </div>
      <header className="no-print sticky top-0 z-30 border-b border-border bg-white" data-id="element-175" data-mp="wl1qymf5ipb">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-3" data-id="element-176" data-mp="3s9fn8yab0uab">
          <Link to="/citizen" className="flex items-center gap-3" data-id="element-177" data-mp="3nbe46dcvouyu">
            <DMPLogo size={46} data-id="element-178" data-mp="3n91pc92f30q0" />
            <div className="leading-tight" data-id="element-179" data-mp="3j99bphy624ds">
              <div className="text-[16px] font-bold text-[#003B71]" data-id="element-180" data-mp="3jb3zr54qicm3">ঢাকা মেট্রোপলিটন পুলিশ</div>
              <div className="text-[12.5px] text-slate-600" data-id="element-181" data-mp="3e8v584c7r2hv">ট্রাফিক প্রসিকিউশন নোটিশ যাচাই</div>
            </div>
          </Link>
          <nav className="ml-auto hidden items-center gap-1 lg:flex" aria-label="প্রধান মেনু" data-id="element-182" data-mp="39d6emqi68vxp">
            {links.map(l => <NavLink key={l.to} to={l.to} end={l.end} className={({
            isActive
          }) => `rounded-md px-3 py-2 text-sm font-medium ${isActive ? 'bg-[#E8F1FA] text-[#003B71]' : 'text-slate-600 hover:bg-muted'}`} data-id="element-183" data-mp="17ki8a8a8dsdp">
                {l.label}
              </NavLink>)}
            <Link to="/citizen/report" className="ml-2 rounded-md bg-[#D93036] px-3.5 py-2 text-sm font-semibold text-white hover:bg-[#bf272d]" data-id="element-184" data-mp="2wzap6gsn2gi8">রিপোর্ট করুন</Link>
          </nav>
          <button className="ml-auto rounded-md p-2 hover:bg-muted lg:hidden" onClick={() => setOpen(o => !o)} aria-label="মেনু" data-id="element-185" data-mp="2n4r619atv70r">
            {open ? <X className="h-5 w-5" data-id="element-186" data-mp="3frv7536sv179" /> : <Menu className="h-5 w-5" data-id="element-187" data-mp="3fsn34f4b70y2" />}
          </button>
        </div>
        {open && <nav className="border-t border-border px-4 py-2 lg:hidden" data-id="element-188" data-mp="3kqy8acjnsn9y">
            {links.map(l => <NavLink key={l.to} to={l.to} end={l.end} className={({
          isActive
        }) => `block rounded-md px-3 py-2.5 text-[15px] ${isActive ? 'bg-[#E8F1FA] font-semibold text-[#003B71]' : 'text-slate-700'}`} data-id="element-189" data-mp="36pvok6g4zp27">{l.label}</NavLink>)}
            <Link to="/citizen/report" className="mt-1 block rounded-md bg-[#D93036] px-3 py-2.5 text-center font-semibold text-white" data-id="element-190" data-mp="1vduwahk2dihp">সন্দেহজনক SMS/নোটিশ রিপোর্ট করুন</Link>
          </nav>}
      </header>
      <div className="no-print border-b border-[#D93036]/20 bg-[#FCE9EA]" data-id="element-191" data-mp="1rvnj0wa6hfqe">
        <div className="mx-auto flex max-w-6xl items-center gap-2 px-4 py-2 text-[13.5px] font-medium text-[#B4232A]" data-id="element-192" data-mp="1muht167wk6kk">
          <AlertTriangle className="h-4 w-4 shrink-0" data-id="element-193" data-mp="21pny9qz6c1cu" /> অপরিচিত SMS বা লিংকের মাধ্যমে অর্থ প্রদান করবেন না।
        </div>
      </div>

      <main className="flex-1" data-id="element-194" data-mp="192jpdawyn2vs">
        <Outlet data-id="element-195" data-mp="193ur756ui0k9" />
      </main>

      <footer className="no-print mt-10 bg-[#003B71] text-white" data-id="element-196" data-mp="19105zbg0cbps">
        <div className="mx-auto grid max-w-6xl gap-6 px-4 py-8 md:grid-cols-3" data-id="element-197" data-mp="145tc0vcjile2">
          <div className="flex items-start gap-3" data-id="element-198" data-mp="1iu7kpmwn142j">
            <DMPLogo size={44} data-id="element-199" data-mp="1iuz4m0gvhdcz" />
            <div data-id="element-200" data-mp="1e261fh11yd30">
              <div className="font-semibold" data-id="element-201" data-mp="1e1nxrzc28wl2">ডিএমপি ট্রাফিক বিভাগ</div>
              <div className="text-sm text-white/70" data-id="element-202" data-mp="qcboz0knaqja">৩৬, শহীদ ক্যাপ্টেন মনসুর আলী সরণি, রমনা, ঢাকা</div>
            </div>
          </div>
          <div className="text-sm" data-id="element-203" data-mp="ld8w0ehxwaro">
            <div className="mb-1 font-semibold" data-id="element-204" data-mp="3krrj8xmd7f48">যোগাযোগ</div>
            <div className="flex items-center gap-1.5 text-white/80" data-id="element-205" data-mp="3ktcdem4row1k"><Phone className="h-3.5 w-3.5" data-id="element-206" data-mp="3ot39n5d2c4dh" /> জরুরি সেবা: ৯৯৯</div>
            <div className="text-white/80" data-id="element-207" data-mp="3ora5pxtu3y96">ওয়েবসাইট: www.dmp.gov.bd</div>
          </div>
          <div className="text-xs text-white/60" data-id="element-208" data-mp="3tr4v1wxyofs4">
            এটি একটি প্রোটোটাইপ প্রদর্শনী। প্রদর্শিত সকল তথ্য নমুনা এবং প্রকৃত ডিএমপি প্রসিকিউশন ডাটাবেসের সাথে সংযুক্ত নয়।
            <div className="mt-2" data-id="element-209" data-mp="7c3d0ijzvk3p"><Link to="/" className="underline" data-id="element-210" data-mp="7clj06wglcot">প্রোটোটাইপ হাব</Link></div>
          </div>
        </div>
      </footer>
    </div>;
}